import { render, staticRenderFns } from "./SwButton.vue?vue&type=template&id=6505ab32"
import script from "./SwButton.vue?vue&type=script&lang=js"
export * from "./SwButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports